module.exports = __webpack_public_path__ + "img/trekio-logo-icon.99c371cb.svg";